import { useEffect, useState } from 'react'

type Time = { h: number; m: number; s: number }

export function useCountdown(initial: Time) {
  const [time, setTime] = useState<Time>(initial)
  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        if (prev.s > 0) return { ...prev, s: prev.s - 1 }
        if (prev.m > 0) return { ...prev, m: prev.m - 1, s: 59 }
        if (prev.h > 0) return { h: prev.h - 1, m: 59, s: 59 }
        return prev
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [])
  const remainingRatio = (time.h * 3600 + time.m * 60 + time.s) / 86400
  const units = [
    { value: time.h, label: 'HS' },
    { value: time.m, label: 'MIN' },
    { value: time.s, label: 'SEG' },
  ]
  return { time, units, remainingRatio }
}
